/**
 * event_tracker
 * Fires either Google Tag Manager or Google Analytics events
 *
 **/
function event_tracker(category, action, label, value) {
  action = action ? action : 'click';

  if (typeof gtag == 'function') {
    var data = {
      'event_category': category,
      'event_label': label,
      'value': value
    };
    gtag('event', action, data);
  }
  else if (typeof ga == 'function') {
    ga('send', 'event', category, action, label, value);
  }
}


// -- Custom jQuery function to get a cached version of a script
var getCachedScript = function(url, options) {
  // Allow user to set any option except for dataType, cache, and url
  options = $.extend(options || {}, {
    dataType: "script",
    cache: true,
    url: url
  });

  // Use $.ajax() since it is more flexible than $.getScript
  // Return the jqXHR object so we can chain callbacks
  return jQuery.ajax(options);
};


// -- Get URL Parameter function
function getURLParameter(sParam) {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');

  for (var i = 0; i < sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] == sParam) {
      sParameterName[1] = sParameterName[1].replace('+', ' ');
      return decodeURIComponent(sParameterName[1]);
    }
  }
}


// -- Google Conversion
function cmg_google_conversion(sDoGoogleConversion, iConversionId, sImageHtml) {
  //set this to FALSE to skip all of the code in this function (instead of deleting the actual code sample)
  var bDoGoogleConversion = false;
  if (sDoGoogleConversion == 'On') { bDoGoogleConversion = true; }

  if (bDoGoogleConversion) {
    var google_conversion_id = iConversionId;
    var google_custom_params = window.google_tag_params;
    var google_remarketing_only = true;

    //inject the 1 pixel image onto the page, thus calling the Google tracking
    $('body').append(sImageHtml);
  }

  return true;
}


/**
 * Defer loading css styles until after page load
 */
var loadDeferredStyles = function() {
  var addStylesNode = document.getElementById("deferred-styles");
  if (addStylesNode != null) {
    var replacement = document.createElement("div");
    replacement.innerHTML = addStylesNode.textContent;
    document.body.appendChild(replacement);
    addStylesNode.parentElement.removeChild(addStylesNode);
  }
};

var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

if (raf) {
  raf(function() { window.setTimeout(loadDeferredStyles, 0); });
}
else {
  window.addEventListener('load', loadDeferredStyles);
}


var htmlOverflow = function(element) {
  if (element.is(':visible')) {
    $('html').css('overflow', 'hidden');
  }
  else {
    $('html').css('overflow', '');
  }
};


// -- Used for IE to replace btoa function
function encode64(input) {
  var keyStr = "ABCDEFGHIJKLMNOP" +
    "QRSTUVWXYZabcdef" +
    "ghijklmnopqrstuv" +
    "wxyz0123456789+/" +
    "=";
  input = escape(input);
  var output = "";
  var chr1, chr2, chr3 = "";
  var enc1, enc2, enc3, enc4 = "";
  var i = 0;

  do {
    chr1 = input.charCodeAt(i++);
    chr2 = input.charCodeAt(i++);
    chr3 = input.charCodeAt(i++);

    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;

    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    }
    else if (isNaN(chr3)) {
      enc4 = 64;
    }

    output = output +
      keyStr.charAt(enc1) +
      keyStr.charAt(enc2) +
      keyStr.charAt(enc3) +
      keyStr.charAt(enc4);
    chr1 = chr2 = chr3 = "";
    enc1 = enc2 = enc3 = enc4 = "";
  } while (i < input.length);

  return output;
}


function alertMessage($type, $message) {
  var $alert = $('#alert');
  if ($alert.length) {
    $alert.addClass('alert--' + $type).text($message).slideDown();
    setTimeout(function() {
      $alert.slideUp(function() {
        $alert.removeClass('alert--' + $type).text('');
      });
    }, 3000);
  }
}


function scriptLoader(deferredScripts) {
  if (deferredScripts && typeof $ != 'undefined') {
    if (deferredScripts.head && Array.isArray(deferredScripts.head) && deferredScripts.head.length) {
      $('head').append(deferredScripts.head.join(''));
    }

    if (deferredScripts.body && Array.isArray(deferredScripts.body) && deferredScripts.body.length) {
      deferredScripts.body.forEach(function(script) {
        $('body').prepend(deferredScripts.body.join(''));
      });
    }

    if (deferredScripts.footer && Array.isArray(deferredScripts.footer) && deferredScripts.footer.length) {
      deferredScripts.footer.forEach(function(script) {
        $('body').append(deferredScripts.footer.join(''));
      });
    }
  }
}

function serializedArrayToObject(serializedArray) {
  var assocObject = {};
  for (i = 0; i < serializedArray.length; i++) {
    var data = serializedArray[i];
    var arrayData = false;
    var key = data.name;

    if (arrayData = data.name.match(/\[\]$/g)) {
      key = key.replace(/\[\]$/g, '');
    }

    if (!assocObject[key]) {
      assocObject[key] = arrayData ? [] : null;
    }

    if (arrayData) {
      assocObject[key].push(data.value);
    } else {
      assocObject[key] = data.value;
    }
  }
  return assocObject;
};
